import { AdminHttpClient } from "../../../../app/api/AdminHttpClient"

// normalizePermissions đã tách sang module thuần dùng chung client + server.
// Re-export để giữ nguyên các import cũ (login page, ChangePassword, AuthWrapper).
export { normalizePermissions } from "@/lib/admin-permissions"

export const loginRequest = async (identifier: string, password: string) => {
  try {
    const response = await AdminHttpClient.post("/api/auth/local", {
      identifier,
      password,
    })
    return response
  } catch (error) {
    console.error("Error in callLogin:", error)
    throw error
  }
}

// Strapi users-permissions forgot-password: emails the user a reset link
// (link target configured in Strapi admin → Settings → Email templates).
// Auth endpoints never need the admin site filter, and the caller is logged
// out here, so we opt out of the domain-filter interceptor explicitly.
export const forgotPassword = async (email: string) => {
  return AdminHttpClient.post(
    "/api/auth/forgot-password",
    { email },
    { skipDomainFilter: true, apiName: "forgotPassword" },
  )
}

// Completes the reset with the `code` from the email link plus the new
// password. On success Strapi returns { jwt, user }.
export const resetPassword = async (code: string, password: string, passwordConfirmation: string) => {
  return AdminHttpClient.post(
    "/api/auth/reset-password",
    { code, password, passwordConfirmation },
    { skipDomainFilter: true, apiName: "resetPassword" },
  )
}

// Đổi mật khẩu cho user ĐANG đăng nhập (JWT được AdminHttpClient tự đính kèm).
// Dùng cho luồng bắt buộc đổi mật khẩu lần đầu. Strapi trả về { jwt, user }.
// Auth endpoint không cần domain filter và không phụ thuộc site nên opt-out.
export const changePassword = async (
  currentPassword: string,
  password: string,
  passwordConfirmation: string,
) => {
  return AdminHttpClient.post(
    "/api/auth/change-password",
    { currentPassword, password, passwordConfirmation },
    { skipDomainFilter: true, apiName: "changePassword" },
  )
}

// Persist the mustChangePassword flag onto the Strapi user record so the
// forced-change gate doesn't re-trigger on the next login. change-password
// itself only returns { jwt, user } and never touches this field, so we
// follow up with an explicit PUT. Users endpoint is site-agnostic → opt out
// of the domain filter.
export const updateMustChangePassword = async (userId: number, mustChangePassword: boolean) => {
  return AdminHttpClient.put(
    `/api/users/${userId}`,
    { mustChangePassword },
    { skipDomainFilter: true, apiName: "updateMustChangePassword" },
  )
}

export const getRoleUser = async () => {
  try {
    const response = await AdminHttpClient.get("/api/users/me?populate=*")
    return response.role
  } catch (error) {
    console.error("Error in getRoleUser:", error)
    throw error
  }
}

export const getCurrentUser = async () => {
  try {
    const user = await AdminHttpClient.get("/api/users/me?populate=*")
    return sanitizeUser(user)
  } catch (error) {
    console.error("Error in getCurrentUser:", error)
    throw error
  }
}

export const sanitizeUser = <T extends Record<string, any> | null | undefined>(user: T): T => {
  if (!user || typeof user !== "object") return user

  const { password, resetPasswordToken, confirmationToken, ...safeUser } = user
  return safeUser as T
}

